import React from 'react'

import SelectProjectMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/project-multi"
import FormManager from "../../../gd-form/common/form-manager"
import CustomView from "../../../model2/custom-view/custom-view"
import quickAdd_getUsersIds from "../../../../app/quick-add/sections/view/components/forms/functions/get-users-ids"
import SelectUsersMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/users-multi"
import SelectOption from "../../../../app/quick-add/sections/view/components/forms/common-blocks/select-option"
import getAvailableProjectsByViewType from "../../functions/get-available-projects"
import {EntityType} from "../../../gd/const/item";

type ActionRequiredConditionsType = {
    projects    : ID[]
    users       : ID[]
    defaultView : string
}

type Props = {
    className?  : string

    view        : CustomView
    disabled?   : boolean
    onChange    : { (conditions: ActionRequiredConditionsType):void }
}

// const debug = "ViewActionRequired_Conditions"
const debug = false

export default function ViewActionRequired_Conditions(props: Props) {

    debug && console.log(debug, 'render', props)

    const onUserChange = () => {
        debug && console.log(debug, 'onUserChange')

        const result = form.getValues()

        const conditions: ActionRequiredConditionsType = {
            projects    : result.projects,
            users       : result.users,
            defaultView : result.defaultView,
        }

        debug && console.log(debug, 'onUserChange conditions', conditions)

        props.onChange(conditions)
    }

    const updateUsersField = (name: string, allUserIds: ID[]) => {
        const users = form.getValue(name);
        const newUsers = _.intersection(users, allUserIds)
        form.setFieldValue(name, newUsers)
    }

    const onParentSelect = (projects: ID[]) => {
        debug && console.log(debug, 'onParentSelect')

        form.onFormComponentValueChange('projects', projects)
        const newUsers = quickAdd_getUsersIds(projects)

        updateUsersField('users', newUsers)

        onUserChange()
    }

    const conditions = props.view.settings

    const initFormData: any = {
        projects    : conditions?.projects || [],
        users       : conditions?.users || [],
        defaultView : conditions?.defaultView || 'overview', //temp, for old views
    }

    const formStructure = {
        fields          : {
            projects        : { type: 'select',   isRequired: false,  label: 'Projects'},
            users           : { type: 'select',   isRequired: false,  label: 'Users',           onUserChange: onUserChange},
            defaultView     : { type: 'select',   isRequired: false,  label: 'Default view',    onUserChange: onUserChange},
        },
        isFormChanged   : true,
    }

    const form = new FormManager(formStructure, initFormData)
    const projectsIds = form.getValue('projects') || []
    const usersIds = quickAdd_getUsersIds(projectsIds)

    const classes = Classes("ui5-form", props.className)

    const defaultViewOptions = [
        { value: 'overview', label: 'Overview' },
        { value: 'detailed', label: 'Detailed view' },
    ]

    return (
        <div className={classes}>
            <div className="tbl">
                <SelectProjectMulti form                = {form}
                                    formFieldName       = 'projects'
                                    availableProjects   = {getAvailableProjectsByViewType(props.view.type)}
                                    disabled            = {props.disabled}
                                    parentsFor          = {EntityType.PROJECT}
                                    onParentSelect      = {onParentSelect}/>

                <SelectUsersMulti label                 = "Users"
                                  form                  = {form}
                                  formFieldName         = 'users'
                                  usersIds              = {usersIds}
                                  includeCurrentUser    = {true}
                                  disabled              = {props.disabled}/>

                <SelectOption label         = "Default view"
                              form          = {form}
                              formFieldName = 'defaultView'
                              options       = {defaultViewOptions}
                              disabled      = {props.disabled}/>
            </div>
        </div>
    )
}
